import { render, staticRenderFns } from "./BupaDiagnosis.vue?vue&type=template&id=6d54189e"
import script from "./BupaDiagnosis.vue?vue&type=script&lang=js"
export * from "./BupaDiagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports